import React from 'react';
import { PriceString } from '@fourthwall/components';
import * as S from './Award.styled';
export const Award = (bonus) => {
    return (React.createElement(S.Award, null,
        "+",
        React.createElement(PriceString, { value: bonus.value, currency: bonus.currency }),
        " ",
        bonus.text || ''));
};
